import { TPhoneCodeOption } from "../types";

type TSearchEvalCb = (option: TPhoneCodeOption) => boolean;

export const createQueryEvaluationCallback =
  (currentQuery: string): TSearchEvalCb =>
  ({ code, label, shortName }): boolean => {
    const phoneCodeQuery = currentQuery.startsWith("+") ? currentQuery : `+${currentQuery}`;
    const isInCode = code.toLowerCase().startsWith(phoneCodeQuery);
    const isInLabel = label.toLowerCase().startsWith(currentQuery);
    const isInShortName = shortName.toLowerCase().startsWith(currentQuery);
    return isInCode || isInLabel || isInShortName;
  };
